import store from '@/stores/store';
import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import documents from './submodules/documents';
import invoiceitems from './submodules/invoiceitems';
import qs from 'qs';
import $utils from '@/utils';
import { CSV_EXPORT_LIMIT } from '@/constants/csv-export';

const { getStorageKey } = utils;

const state = {
    shipment: null,
    shipment_loading: false,
    shipment_loading_errors: null,
    shipment_saving: false,
    shipment_saving_errors: null,

    updating_shipment_status: false,
    assigning_shipment: false,

    deleting_shipment: false,
    deleting_shipment_errors: null,

    shipmentitem: false,
    shipmentitem_loading: false,
    shipmentitem_loading_errors: null,
    shipmentitem_saving: false,
    shipmentitem_saving_errors: null,
    shipmentitem_deleting: false,
    shipmentitem_deleting_errors: null,

    shipmentitems: null,
    shipmentitems_count: 0,
    shipmentitems_filters: { limit: 20 },
    shipmentitems_loaded: false,
    shipmentitems_loading: false,
    shipmentitems_loading_errors: null,
    shipmentitems_cancel_source: null,

    customers: [],
    customers_count: 0,
    customers_loading: false,
    customers_loading_errors: null,

    deliverysites: [],
    deliverysites_count: 0,
    deliverysites_loading: false,
    deliverysites_loading_errors: null,

    stocks: [],
    stocks_count: 0,
    stocks_loading: false,
    stocks_loading_errors: null,

    stockproducts: [],
    stockproducts_filters: { offset: 0, limit: 20, },
    stockproducts_count: 0,
    stockproducts_loaded: false,
    stockproducts_loading: false,
    stockproducts_loading_errors: null,
    stockproducts_cancel_source: null,

    products: [],
    products_filters: { offset: 0, limit: 20, },
    products_count: 0,
    products_loaded: false,
    products_loading: false,
    products_loading_errors: null,
    products_cancel_source: null,

    events: [],
    events_filters: {},
    events_loading: false,
    events_loaded: false,
    events_loading_errors: null,
    events_count: 0,

    setting_shipment_readyness: false,
    setting_shipmentitem_status: false,

    shipment_stats: {},
    shipment_stats_loading: false,
    shipment_stats_loading_errors: null,
    shipment_stats_loaded: false,

    linked_customer_orders: [],
    linked_customer_orders_loading: false,
    linked_customer_orders_loading_errors: null,
    linked_customer_orders_loaded: false,
};


const mutations = {
    updateShipment(state, shipment) {

        if (shipment && state.shipment && state.shipment.shipment_id == shipment.shipment_id) {
            state.shipment = shipment;
            // Keep linked orders; refresh is triggered by fetchShipment / init.
            return;
        }

        state.shipment = shipment;

        state.shipmentitems = [];
        state.shipmentitems_count = 0;
        state.shipmentitems_loaded = false;

        state.stockproducts = [];
        state.stockproducts_count = 0;
        state.stockproducts_loaded = false;
        state.stockproducts_loading = false;
        state.stockproducts_loading_errors = null;

        state.products = [];
        state.products_count = 0;
        state.products_loaded = false;
        state.products_loading = false;
        state.products_loading_errors = null;

        state.events = [];
        state.events_count = 0;
        state.events_loaded = false;
        state.events_loading_errors = null;

        state.linked_customer_orders = [];
        state.linked_customer_orders_loaded = false;
        state.linked_customer_orders_loading = false;
        state.linked_customer_orders_loading_errors = null;

        if (!shipment) {
            state.shipmentitems_filters = { offset: 0, limit: state.shipmentitems_filters.limit };
            state.stockproducts_filters = { offset: 0, limit: state.stockproducts_filters.limit };
            state.products_filters = { offset: 0, limit: state.products_filters.limit };
            state.events_filters = { object_type: 'shipment', ordering: "-event_date" };
            return;
        }

        state.shipmentitems_filters = { offset: 0, limit: state.shipmentitems_filters.limit };
        state.stockproducts_filters = { offset: 0, limit: state.stockproducts_filters.limit, stock: shipment.stock };
        state.products_filters = { offset: 0, limit: state.products_filters.limit };
        state.events_filters = { object_type: 'shipment', object_id: shipment.shipment_id, ordering: "-event_date" };

        if (state.shipmentitems_cancel_source) {
            state.shipmentitems_cancel_source.cancel("canceled");
            state.shipmentitems_cancel_source = null;
        }
        if (state.stockproducts_cancel_source) {
            state.stockproducts_cancel_source.cancel("canceled");
            state.stockproducts_cancel_source = null;
        }
        if (state.products_cancel_source) {
            state.products_cancel_source.cancel("canceled");
            state.products_cancel_source = null;
        }

    },
    updateShipmentLoading(state, loading) {
        state.shipment_loading = loading;
    },
    updateShipmentLoadingErrors(state, errors) {
        state.shipment_loading_errors = errors;
    },
    updateShipmentSaving(state, saving) {
        state.shipment_saving = saving;
    },
    updateShipmentSavingErrors(state, errors) {
        state.shipment_saving_errors = errors;
    },
    updateLinkedCustomerOrders(state, orders) {
        state.linked_customer_orders = orders || [];
        state.linked_customer_orders_loaded = true;
    },
    updateLinkedCustomerOrdersLoading(state, loading) {
        state.linked_customer_orders_loading = loading;
    },
    updateLinkedCustomerOrdersLoadingErrors(state, errors) {
        state.linked_customer_orders_loading_errors = errors;
    },

    updateUpdatingShipmentStatus(state, status) {
        state.updating_shipment_status = status;
    },

    updateShipmentDeleting(state, deleting) {
        state.deleting_shipment = deleting;
    },
    updateShipmentDeletingErrors(state, errors) {
        state.deleting_shipment_errors = errors;
    },


    updateShipmentItem(state, shipmentitem) {
        state.shipmentitem = shipmentitem;
    },
    updateShipmentItemLoading(state, loading) {
        state.shipmentitem_loading = loading;
    },
    updateShipmentItemLoadingErrors(state, errors) {
        state.shipmentitem_loading_errors = errors;
    },
    updateShipmentItemSaving(state, saving) {
        state.shipmentitem_saving = saving;
    },
    updateShipmentItemSavingErrors(state, errors) {
        state.shipmentitem_saving_errors = errors;
    },
    updateShipmentItemDeleting(state, deleting) {
        state.shipmentitem_deleting = deleting;
    },
    updateShipmentItemDeletingErrors(state, errors) {
        state.shipmentitem_deleting_errors = errors;
    },


    updateShipmentItems(state, shipmentitems) {
        state.shipmentitems = shipmentitems;
        state.shipmentitems_loaded = true;
    },
    updateShipmentItemsCount(state, count) {
        state.shipmentitems_count = count;
    },
    updateShipmentItemsFilters(state, shipmentitems_filters) {
        state.shipmentitems_filters = Object.assign(
            {
                limit: state.shipmentitems_filters.limit || 20,
                ordering: state.shipmentitems_filters.ordering,
            },
            shipmentitems_filters);
    },
    updateShipmentItemsLoading(state, loading) {
        state.shipmentitems_loading = loading;
    },
    updateShipmentItemsLoadingErrors(state, errors) {
        state.shipmentitems_loading_errors = errors;
    },
    updateShipmentItemsCancelSource(state, shipmentitems_cancel_source) {
        state.shipmentitems_cancel_source = shipmentitems_cancel_source;
    },



    updateCustomers(state, customers) {
        state.customers = customers;
    },
    updateCustomersCount(state, count) {
        state.customers_count = count;
    },
    updateCustomersLoading(state, loading) {
        state.customers_loading = loading;
    },
    updateCustomersLoadingErrors(state, errors) {
        state.customers_loading_errors = errors;
    },

    updateDeliverySites(state, deliverysites) {
        state.deliverysites = deliverysites;
    },
    updateDeliverySitesCount(state, count) {
        state.deliverysites_count = count;
    },
    updateDeliverySitesLoading(state, loading) {
        state.deliverysites_loading = loading;
    },
    updateDeliverySitesLoadingErrors(state, errors) {
        state.deliverysites_loading_errors = errors;
    },

    updateStocks(state, stocks) {
        state.stocks = stocks;
    },
    updateStocksLoading(state, loading) {
        state.stocks_loading = loading;
    },
    updateStocksLoadingErrors(state, errors) {
        state.stocks_loading_errors = errors;
    },
    updateStocksCount(state, count) {
        state.stocks_count = count;
    },

    updateStockProducts(state, stockproducts) {
        state.stockproducts = stockproducts;
        state.stockproducts_loaded = true;
    },
    updateStockProductsFilters(state, stockproducts_filters) {
        const prev = state.stockproducts_filters || {};
        const next = { ...stockproducts_filters };
        if (prev.stock !== next.stock) {
            delete next.stock_owner;
        }
        state.stockproducts_filters = next;
    },
    updateStockProductsCount(state, stockproducts_count) {
        state.stockproducts_count = stockproducts_count;
    },
    updateStockProductsLoading(state, loading) {
        state.stockproducts_loading = loading;
    },
    updateStockProductsLoadingErrors(state, errors) {
        state.stockproducts_loading_errors = errors;
    },
    updateStockProductsCancelSource(state, source) {
        state.stockproducts_cancel_source = source;
    },

    updateProducts(state, products) {
        state.products = products;
        state.products_loaded = true;
    },
    updateProductsLoading(state, loading) {
        state.products_loading = loading;
    },
    updateProductsLoadingErrors(state, errors) {
        state.products_loading_errors = errors;
    },
    updateProductsCount(state, count) {
        state.products_count = count;
    },
    updateProductsCancelSource(state, source) {
        state.products_cancel_source = source;
    },

    updateEvents(state, events) {
        state.events = events;
    },
    updateEventsLoading(state, events_loading) {
        state.events_loading = events_loading;
    },
    updateEventsLoadingErrors(state, events_loading_errors) {
        state.events_loading_errors = events_loading_errors;
    },
    updateEventsCount(state, events_count) {
        state.events_count = events_count;
    },
    updateAssigningShipment(state, assigning_shipment) {
        state.assigning_shipment = assigning_shipment;
    },

    updateSettingShipmentReadyness(state, setting_shipment_readyness) {
        state.setting_shipment_readyness = setting_shipment_readyness;
    },

    updateShipmentStats(state, shipment_stats) {
        state.shipment_stats = shipment_stats;
    },
    updateShipmentStatsLoading(state, loading) {
        state.shipment_stats_loading = loading;
    },
    updateShipmentStatsLoadingErrors(state, errors) {
        state.shipment_stats_loading_errors = errors;
    },
    updateShipmentStatsLoaded(state, loaded) {
        state.shipment_stats_loaded = loaded;
    },

    updateSettingShipmentItemStatus(state, setting_shipmentitem_status) {
        state.setting_shipmentitem_status = setting_shipmentitem_status;
    }
};

const actions = {

    async fetchEvents({ commit, state }) {
        commit('updateEventsLoading', true);

        try {
            const response = await axios.get('/api/events/', { params: state.events_filters });
            commit('updateEvents', response.data.results);
            commit('updateEventsCount', response.data.count);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateEventsLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateEventsLoading', false);
        }
    },

    async fetchShipment({ commit, dispatch, state }, params) {
        commit('updateShipmentLoading', true);
        commit('updateShipmentLoadingErrors', null);

        try {
            const response = await axios.get(`/api/shipments/${state.shipment.shipment_id}/`);
            commit('updateShipmentLoading', false);
            commit('updateShipment', response.data);
            dispatch('fetchShipmentStats');
            dispatch('fetchLinkedCustomerOrders');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateShipmentLoading', false);
            commit('updateShipmentLoadingErrors', error.details);
            throw error;
        }
    },

    async fetchLinkedCustomerOrders({ commit, state }) {
        if (!state.shipment?.shipment_id) {
            commit('updateLinkedCustomerOrders', []);
            return;
        }
        commit('updateLinkedCustomerOrdersLoading', true);
        commit('updateLinkedCustomerOrdersLoadingErrors', null);
        try {
            const response = await axios.get(
                `/api/shipments/${state.shipment.shipment_id}/customerorders/`,
                { params: { limit: 100 } },
            );
            const results = response.data?.results ?? response.data ?? [];
            commit('updateLinkedCustomerOrders', results);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateLinkedCustomerOrders', []);
            commit('updateLinkedCustomerOrdersLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateLinkedCustomerOrdersLoading', false);
        }
    },

    async setShipmentReadyness({ commit, dispatch, state }, params) {
        commit('updateSettingShipmentReadyness', true);

        try {
            const url = `/api/shipments/${state.shipment.shipment_id}/ready/`;
            const response = await axios.put(url, { ready: params.ready })
            await dispatch('fetchShipment');
            dispatch('fetchEvents');
            dispatch('session/fetchStats', null, { root: true });

            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        } finally {
            commit('updateSettingShipmentReadyness', false);
        }
    },

    async setShipmentStatus({ commit, dispatch, state }, params) {
        commit('updateUpdatingShipmentStatus', true);

        try {
            const url = `/api/shipments/${state.shipment.shipment_id}/status/`;
            const payload = { status: params.status, ...(params.storage_allocations ? { storage_allocations: params.storage_allocations } : {}) };
            if (params.delivered_date) {
                payload.delivered_date = params.delivered_date;
            }
            return await axios.put(url, payload)
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        } finally {
            commit('updateUpdatingShipmentStatus', false);
            await dispatch('fetchShipment');
            dispatch('invoiceitems/fetchInvoiceItems');
            dispatch('fetchShipmentItems');
            dispatch('fetchEvents');
            dispatch('session/fetchStats', null, { root: true });
        }
    },

    async deleteShipment({ commit, dispatch }, params) {
        try {
            commit('updateShipmentDeleting', true);
            commit('updateShipmentDeletingErrors', null);
            const url = `/api/shipments/${params.instance.shipment_id}/`;
            const response = await axios.delete(url);
            commit('updateShipmentDeleting', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateShipmentDeleting', false);
            if (error.details) {
                commit('updateShipmentDeletingErrors', error.details);
            }
            throw error;
        } finally {
            dispatch('session/fetchStats', null, { root: true });
        }
    },

    async archiveShipment({ dispatch, state }, params) {
        const shipmentId = params?.instance?.shipment_id || state.shipment?.shipment_id;
        try {
            const response = await axios.post(`/api/shipments/${shipmentId}/archive/`);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            dispatch('fetchShipment');
            dispatch('session/fetchStats', null, { root: true });
        }
    },

    async unarchiveShipment({ dispatch, state }, params) {
        const shipmentId = params?.instance?.shipment_id || state.shipment?.shipment_id;
        try {
            const response = await axios.post(`/api/shipments/${shipmentId}/unarchive/`);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            dispatch('fetchShipment');
            dispatch('session/fetchStats', null, { root: true });
        }
    },

    async deleteShipmentItem({ commit, dispatch, state }, params) {
        commit('updateShipmentItemDeleting', true);
        commit('updateShipmentItemDeletingErrors', null);

        try {
            const url = `/api/shipmentitems/${params.instance.id}/`;
            const response = await axios.delete(url);
            commit('updateShipmentItemDeleting', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateShipmentItemDeleting', false);
            commit('updateShipmentItemDeletingErrors', error.details);
            throw error;
        } finally {
            await dispatch('fetchShipment');
            await dispatch('fetchShipmentItems');
            if (state.shipment?.stock_data?.track_stock) {
                await dispatch('fetchStockProducts');
            } else {
                await dispatch('fetchProducts');
            }
        }
    },

    async setShipmentItemStatus({ commit, dispatch, state }, params) {
        const url = `/api/shipmentitems/${params.shipmentitem.id}/status/`;

        try {
            commit('updateSettingShipmentItemStatus', true);
            const response = await axios.put(url, {
                status: params.status,
                received_count: params.received_count,
            });
            await dispatch('fetchShipment');
            await dispatch('fetchShipmentItems');
            dispatch('fetchEvents');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        } finally {
            commit('updateSettingShipmentItemStatus', false);
        }
    },

    async fetchShipmentItems({ commit, dispatch, state }, params) {
        commit('updateShipmentItemsLoading', true);
        commit('updateShipmentItemsLoadingErrors', null);

        if (state.products_cancel_source) {
            state.products_cancel_source.cancel("canceled");
        }
        commit('updateShipmentItemsCancelSource', axios.CancelToken.source());
        try {
            const response = await axios.get("/api/shipmentitems/", {
                params: Object.assign({
                    shipment: state.shipment.shipment_id,
                    stock: state.shipment.stock,
                }, state.shipmentitems_filters
                ),
                cancelToken: state.shipmentitems_cancel_source?.token,
            });

            commit('updateShipmentItems', response.data.results);
            commit('updateShipmentItemsCount', response.data.count);
            commit('updateShipmentItemsCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateShipmentItemsLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateShipmentItemsLoading', false);
        }
    },


    async fetchStockProducts({ commit, dispatch, state }, params) {
        commit('updateStockProductsLoading', true);
        commit('updateStockProductsLoadingErrors', null);

        if (state.stockproducts_cancel_source) {
            state.stockproducts_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateStockProductsCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/stockproducts/', {
                params: state.stockproducts_filters,
                cancelToken: state.stockproducts_cancel_source?.token,
            });

            commit('updateStockProductsLoading', false);
            commit('updateStockProducts', response.data.results);
            commit('updateStockProductsCount', response.data.count);
            commit('updateStockProductsCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            let error = utils.handleError(xhr_error);
            commit('updateStockProductsLoadingErrors', error.details);
            commit('updateStockProductsLoading', false);
            commit('updateStockProductsCancelSource', null);
            throw error;
        }
    },

    async fetchProducts({ commit, dispatch, state }, params) {
        commit('updateProductsLoading', true);
        commit('updateProductsLoadingErrors', null);

        if (state.products_cancel_source) {
            state.products_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateProductsCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/products/', {
                params: state.products_filters,
                cancelToken: state.products_cancel_source?.token,
            });

            commit('updateProductsLoading', false);
            commit('updateProducts', response.data.results);
            commit('updateProductsCount', response.data.count);
            commit('updateProductsCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            let error = utils.handleError(xhr_error);
            commit('updateProductsLoadingErrors', error.details);
            commit('updateProductsLoading', false);
            commit('updateProductsCancelSource', null);
            throw error;
        }
    },

    async assignShipment({ commit, dispatch, state }, params) {
        const url = `/api/shipments/${state.shipment.shipment_id}/assign/`;
        commit('updateAssigningShipment', true);

        try {
            const response = await axios.put(url, { user: params.user });
            dispatch('fetchShipment');
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit('updateAssigningShipment', false);
            dispatch('fetchEvents');
            dispatch('session/fetchStats', null, { root: true });
        }
    },

    async fetchShipmentStats({ commit, dispatch, state }, params) {
        commit('updateShipmentStatsLoading', true);
        commit('updateShipmentStatsLoadingErrors', null);
        try {
            const response = await axios.get(`/api/shipments/${state.shipment.shipment_id}/stats/`);
            commit('updateShipmentStats', response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateShipmentStatsLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateShipmentStatsLoading', false);
        }
    },

    exportShipmentItemsAsCSV({ commit, dispatch, state }, params) {
        let filters = {
            format: 'csv',
            limit: CSV_EXPORT_LIMIT,
            shipment: state.shipment.shipment_id,
        };
        
        const shipmentId = state.shipment?.shipment_id || state.shipment?.id || '';
        
        $utils.downloadFile({
            url: "/api/shipmentitems/",
            params: filters,
        }, $utils.getFilename('shipmentItems', { shipment_id: shipmentId }));
    },

    async duplicateShipment({ commit, dispatch, state }, params) {
        try {
            const url = `/api/shipments/${state.shipment.id}/duplicate/`;
            const response = await axios.post(url);
            dispatch('session/fetchStats', null, { root: true });
            return response;
        } catch (xhr_error) {
            return Promise.reject(utils.handleError(xhr_error));
        }
    },

    update({ commit, dispatch, state }, params) {
        if (!state.shipment) {
            return;
        }
        dispatch('fetchShipment');
        dispatch('fetchShipmentStats');
        dispatch('fetchShipmentItems');
        dispatch('fetchEvents');
        dispatch('documents/fetchDocuments');
        dispatch('invoiceitems/fetchInvoiceItems');
        if (state.shipment.stock_data?.track_stock) {
            dispatch('fetchStockProducts');
        } else {
            dispatch('fetchProducts');
        }
    },

    init({ commit, dispatch, state }, params) {
        commit('updateShipment', params.shipment);
        dispatch('fetchShipmentStats');
        dispatch('fetchEvents');
        dispatch('fetchShipmentItems');
        dispatch('fetchLinkedCustomerOrders');

        dispatch('invoiceitems/init', { shipment: params.shipment, url: `/api/shipments/${params.shipment.shipment_id}/invoiceitems/`, filters: { billed: params.shipment.customer } });
        dispatch('invoiceitems/fetchInvoiceItems');

        if (!params.shipment.ready) {
            if (params.shipment.stock_data?.track_stock) {
                dispatch('fetchStockProducts');
            } else {
                dispatch('fetchProducts');
            }
        }

        let shared_with = null;
        if (store.getters['session/current_entity_id'] !== params.shipment.initiator) {
            shared_with = params.shipment.initiator;
        }
        dispatch('documents/init', {
            tags: `shipment:${params.shipment.shipment_id}`,
            shared_with,
            create_tags: [
                `shipment:${params.shipment.shipment_id}`
            ]
        });
        dispatch('documents/fetchDocuments');
    },


};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        documents: documents({
            storageKey: getStorageKey('shipment', 'documents'),
            fieldsToSave: ['limit', 'ordering']
        }),
        invoiceitems: invoiceitems({
            storageKey: getStorageKey('shipment', 'invoiceitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
    }
};
